import { render } from "./ColumnRuleWidth.vue?vue&type=template&id=078456dd&scoped=true&ts=true"
import script from "./ColumnRuleWidth.vue?vue&type=script&lang=ts"
export * from "./ColumnRuleWidth.vue?vue&type=script&lang=ts"

import "./ColumnRuleWidth.vue?vue&type=style&index=0&id=078456dd&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078456dd"]])

export default __exports__